var $ = require('jQuery');
var template = require('../../template/msg/msg-list.html');
/*require('./../../style/msg/msg-list.less');*/
var Component = require('./../Component');
var TextMsgItem = require('./TextMsgItem');
var ImageMsgItem = require('./ImageMsgItem');
var FileMsgItem = require('./FileMsgItem');
var VideoMsgItem = require('./VideoMsgItem');
var TipMsgItem = require('./TipMsgItem');
var CardMsgItem = require('./CardMsgItem');
var CardMsgItem4 = require('./CardMsgItem4');
var CardMsgItem5 = require('./CardMsgItem5');
var CardMsgItemGanji = require('./CardMsgItemGanji');
var CardMsgJob = require('./CardMsgJob');
var MiniCardMsgItem = require('./MiniCardMsgItem');
var AudioMsgItem = require('./AudioMsgItem');
var MixMsgItem = require('./MixMsgItem');
var CardMsgMutual = require('./CardMsgMutual');
var CardMsgEvaluate1 = require('./CardMsgEvaluate1');
var CardMsgEvaluate2 = require('./CardMsgEvaluate2');
var ShopMsgCardItem = require('./ShopMsgCardItem');
var FalseMsgItem = require('./FalseMsgItem');
var ProvideContactinfoCard = require('./ProvideContactinfoCard');
var DefaultContactinfoCard = require('./DefaultContactinfoCard');
var CardBatchMsgItem = require('./CardBatchMsgItem');
var ChatCardItem = require('./ChatCardItem');
var RemindMsgItem = require('./RemindMsgItem');
var ActionType = require('./../../constant/ActionType');
var MultipleContentMenu = require('./../../constant/MultipleContentMenu');
var dispatcher = require('./../../global/dispatcher');
var config = require('./../../global/config');
var strToNumCompare = require('./../../../lib/util').strToNumCompare;
var utils = require('./../../global/utils');
var isShopModeUser = utils.isShopModeUser;
var isEmpty = utils.isEmpty;
var _jsonHandler = utils.jsonHandler;
var _standardEvaluateCardList = ['standard_evaluate_card1', 'standard_evaluate_card2'];

var non_contentmenu_show_types = MultipleContentMenu.non_contentmenu_show_types;

var non_multiple_selected_show_types = MultipleContentMenu.non_multiple_selected_show_types;

var non_delete_show_types = MultipleContentMenu.non_delete_show_types;

var convert = function (msg) {
  // 消息转换
  msg = config['msg-show-converter'](msg);

  if (typeof msg.content === 'string') {
    msg.content = _jsonHandler.parse(msg.content);
  }

  var msg_show_type = msg.show_type;

  
  if (!config['is_support_provide_contactinfo'] && ['provide_contactinfo_card', 'default_contactinfo_card'].indexOf(msg_show_type) >= 0) {
    msg_show_type = null;
  }

  if (!config['is_support_forward'] && ['msg_batch_forward_card'].indexOf(msg_show_type) >= 0) {
    msg_show_type = null;
  }

  switch (msg_show_type) {
    case 'audio':
    case 'video':
      var msgText = msg.show_type === 'video' ? '视频' : '语音';
      // 针对IE8及以下浏览器不支持audio标签，转换显示文案
      if (!(document.createElement('video').canPlayType)) {
        msg.show_type = 'text';
        msg.content = {
          type: 'text',
          msg: '浏览器版本不支持' + msgText + '播放，请升级浏览器'
        };
      }
      break;
    case 'text':
    case 'tip':
    case 'modify_msg':
    case 'auth_tip':
    case 'operation_tip':
    case 'card':
    case 'minicard':
    case 'universal_card1':
    case 'universal_card2':
    case 'universal_card3':
    case 'mix':
    case 'universal_card4':
    case 'universal_card5':
    case 'universal_card6':
    case 'standard_evaluate_card1':
    case 'standard_evaluate_card2':
    case 'private_card_ganji':
    case 'shop_common_card':
    case 'wuba_card':
    case 'file':
    case 'false_msg':
    case 'provide_contactinfo_card':
    case 'default_contactinfo_card':
      break;
    case 'msg_batch_forward_card':
      if (!isEmpty(msg.content) && msg.content.forward_one_by_one) {
        var forward_original_show_type = msg.show_type;
        var forward_original_content = msg.content;
        msg.show_type = msg.forward_msg_show_type;
        msg.content = msg.forward_msg_content;
        msg.forward_original_show_type = forward_original_show_type;
        msg.forward_original_content = forward_original_content;
      }
    case 'chat_card':
      break;
    case 'location':
      msg._original_show_type = msg.show_type;
      msg._original_content = msg.content;
      msg.show_type = 'text';
      msg.content = {
        type: 'text',
        msg: '消息格式暂不支持，请在客户端查看'
      };
      break;
    case 'call_audio':
      msg.show_type = 'text';
      msg.content = {
        type: 'text',
        msg: '[收到一条语音聊天消息，请在手机上查看]'
      };
      break;
    case 'call_video':
      msg.show_type = 'text';
      msg.content = {
        type: 'text',
        msg: '[收到一条视频聊天消息，请在手机上查看]'
      };
      break;
    case 'image':
      msg.content.image_width = parseFloat(msg.content.image_width);
      msg.content.image_height = parseFloat(msg.content.image_height);
      break;
    case 'wechat_notice_card':
      break;
    default:
      msg._original_show_type = msg.show_type;
      msg._original_content = msg.content;
      // 不支持消息体的默认展示文案
      if (msg && msg.content && msg.content.common_default_text) {
        msg.show_type = 'tip';
        msg.content = {
          type: 'tip',
          text: msg.content.common_default_text,
          extra: msg.content.common_default_text
        };
      } else {
        msg.show_type = 'text';
        msg.content = {
          type: 'text',
          msg: '消息格式暂不支持，请在客户端查看'
        };
      }
      break;
  }

  var me = config['me']();
  var meKey = me.user_id + '@' + me.user_source;
  var toKey = msg.to_id + '@' + msg.to_source;
  var senderKey = msg.sender_info ? msg.sender_info.user_id + '@' + msg.sender_info.user_source : msg.sender_id + '@' + msg.sender_source;
  if (meKey == senderKey || (isShopModeUser({ user_source: msg.sender_source }) && meKey != senderKey && meKey != toKey)) {
    msg.is_mine = true;
  }
  else {
    msg.is_mine = false;
  }
  return msg;
};

var factory = function (msg) {
  msg = convert(msg);

  var result = null;
  switch (msg.show_type) {
    case 'text':
      result = TextMsgItem;
      // likd-a , test code
      if (msg.msg_id === '1335147446749151232') {
        msg.show_type = 'wechat_notice_card';
        result = RemindMsgItem;
      }
      break;
    case 'image':
      result = ImageMsgItem;
      break;
    case 'file':
      result = FileMsgItem;
      break;
    case 'video':
      result = VideoMsgItem;
      break;
    case 'modify_msg':
    case 'auth_tip':
    case 'operation_tip':
    case 'tip':
      result = TipMsgItem;
      break;
    case 'card':
      result = CardMsgItem;
      break;
    case 'minicard':
    case 'universal_card2':
      result = MiniCardMsgItem;
      break;
    case 'audio':
      result = AudioMsgItem;
      break;
    case 'mix':
    case 'universal_card1':
    case 'universal_card3':
      result = MixMsgItem;
      break;
    case 'universal_card4':
      result = CardMsgItem4;
      break;
    case 'universal_card5':
      result = CardMsgItem5;
      break;
    case 'universal_card6':
      result = CardMsgMutual;
      break;
    case 'standard_evaluate_card1':
      result = CardMsgEvaluate2;
      break;
    case 'standard_evaluate_card2':
      result = CardMsgEvaluate1;
      break;
    case 'private_card_ganji':
      result = CardMsgItemGanji;
      break;
    case 'wuba_card':
      result = CardMsgJob;
      break;
    case 'shop_common_card':
      result = ShopMsgCardItem;
      break;
    case 'false_msg':
      result = FalseMsgItem;
      break;
    case 'provide_contactinfo_card':
      result = ProvideContactinfoCard;
      break;
    case 'default_contactinfo_card':
      result = DefaultContactinfoCard;
      break;
    case 'msg_batch_forward_card':
      result = CardBatchMsgItem;
      break;
    case 'chat_card':
      result = ChatCardItem;
      break;
    case 'wechat_notice_card':
      result = RemindMsgItem;
    default:
      break;
  }

  return result;
};

var multiple_select = function (e) {
  var self = this;
  var _target = $(e.target);
  if (!(_target.hasClass('im-msg'))) _target = _target.parents('.im-msg');
  var msg_id = _target.data('msg-id');
  if (msg_id) {
    var msgId = self.createKey(msg_id);
    var msgitem = (self._children[msgId] && self._children[msgId]._data) ? self._children[msgId]._data.msg : null;
    if (isEmpty(msgitem)) return;
    if (!(isEmpty(msgitem.status) || msgitem.status === 'SUCCESS' || msgitem.status === 'DOWNLOADED')) return;
    //if (msgitem.is_false_new) return;
    // var imExtra = msgitem.content && msgitem.content.imExtra ? msgitem.content.imExtra : '{}';
    // try {
    //   imExtra = JSON.parse(imExtra);
    // } catch (e) {
    //   imExtra = null;
    // }
    //if (non_contentmenu_show_types.indexOf(msgitem.show_type) >= 0 || imExtra && imExtra.isAIMsg === true) {
    if (non_multiple_selected_show_types.indexOf(msgitem.show_type) >= 0) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    if (_target.hasClass('im-msg-selected')) {
      _target.removeClass('im-msg-selected');
    } else if (this._element.find('.im-msg-selected').length < 50) {
      _target.addClass('im-msg-selected');
    } else {
      dispatcher.dispatch({
        type: ActionType.TOAST_SHOW,
        data: {
          content: `最多选择50条消息`,
          interval: 3000
        }
      });
    }
  }
};

var createMsgItem = function (msg) {
  var self = this;
  var MsgItem = factory(msg);
  var item = null;

  var options = {};
  if (MsgItem === ImageMsgItem) {
    options.onImageClick = function () {
      var current = -1;
      var index = -1;
      var images = [];
      for (var i = 0, length = self._msg_ids.length; i < length; i++) {
        var id = self._msg_ids[i];
        var key = self.createKey(id);
        var comp = self._children[key];
        var imgitem = comp.getMsg();
        if (imgitem.show_type == 'image') {
          index++;
          images.push({
            src: imgitem.content.url,
            image_width: imgitem.content.image_width,
            image_height: imgitem.content.image_height
          });

          if (strToNumCompare(msg.msg_id, imgitem.msg_id) == 0) {
            current = index;
          }
        }
      }

      dispatcher.dispatch({
        type: ActionType.IMAGE_CLICK,
        data: {
          images: images,
          current: current
        }
      });
    };
  }
  if (!isEmpty(self._options.me)) {
    options.me = self._options.me;
  }

  //if (MsgItem === TipMsgItem || MsgItem === FalseMsgItem) {
  if (MsgItem === TipMsgItem) {
    options.multiple_selectable = false;
  } else {
    options.multiple_selectable = true;
  }

  if (typeof MsgItem === 'function') {
    item = new MsgItem(options);
    item.setMsg(msg);
  }

  // sdk层进行过滤
  /*if (MsgItem === TipMsgItem && msg.is_mine) {
   item.hide();
   }*/

  return item;
};

var getPosition = function (msg) {
  var self = this;
  var position = 0;
  var len = self._msg_sorttime.length;
  var msg_sorttime = { msg_id: msg.msg_id, sort_time: msg.sort_time };
  $.each(self._msg_sorttime, function (index, value) {
    position = index;
    if (msg.msg_id && value.msg_id && msg.msg_id > 0 && value.msg_id > 0 && strToNumCompare(msg.msg_id, value.msg_id) < 0) {
      return false;
    } else if (msg.msg_id && value.msg_id && strToNumCompare(msg.msg_id, value.msg_id) == 0) {
      if (msg.sort_time < value.sort_time) {
        position--
      }
    }

    if (index === len - 1) {
      position++;
    }
  });

  if (position < len) {
    self._msg_sorttime.splice(position, 0, msg_sorttime);
  }
  else {
    self._msg_sorttime.push(msg_sorttime);
  }

  // 修改逻辑，只能在顶部和底部添加消息
  /*   if (msg.msg_id && msg.msg_id > 0 && len > 0 && self._msg_sorttime[0].msg_id && strToNumCompare(msg.msg_id, self._msg_sorttime[0].msg_id) < 0) {
      position = 0;
      self._msg_sorttime.unshift(msg_sorttime);
    } else {
      position = len;
      self._msg_sorttime.push(msg_sorttime);
    } */
  return position;
};

var MsgList = function (options) {
  (function (self) {
    var defaults = {
      template: template,
      onPositionChanged: function () {
      }
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  (function (self) {
    self._msg_ids = [];
    self._msg_sorttime = [];   //{key:id;value:sort_time(用来确定消息的插入位置)}
    self._last_timestamp;
    self._multiple_select = multiple_select.bind(self);
  })(this);

  (function (self) {
    function closeMenu(e) {
      var _target = $(e.target);
      if (_target.hasClass('im-menu-selection') || _target.hasClass('im-content-menu')) {
        return;
      }
      self.triggerEvent('contentMenuClose');
      document.oncontextmenu = function () {
        return true;
      };
      $(document).off('mousedown', closeMenu);
    }
    self._element.mousedown(function (e) {
      var _target = $(e.target);
      if (e.which == 3 && !self._options.multiple_select) {
        var originMenu = _target.hasClass('im-msg-content') || _target.parents('.im-msg-content') || _target.parents('.im-chat-msg-contents');
        var msgId = _target.data('msg-id') || _target.parents('.im-msg-content').data('msg-id') || _target.parents('.im-chat-msg-contents').data('msg-id');
        // if(msgId < 0)return;
        msgId = self.createKey(msgId);
        var msgitem = (self._children[msgId] && self._children[msgId]._data) ? self._children[msgId]._data.msg : null;
        // if (originMenu && msgId && msgitem && msgitem.status === "SUCCESS") {
        if (originMenu && msgId && msgitem) {
          var time = parseInt((Date.now() - self._children[msgId]._data.msg.send_time) / 1000);
          //if (msgitem.is_false_new) return;
          // var imExtra = msgitem.content && msgitem.content.imExtra ? msgitem.content.imExtra : '{}';
          // try {
          //   imExtra = JSON.parse(imExtra);
          // } catch (e) {
          //   imExtra = null;
          // }
          //if (non_contentmenu_show_types.indexOf(msgitem.show_type) >= 0 || imExtra && imExtra.isAIMsg === true) {
          if (non_contentmenu_show_types.indexOf(msgitem.show_type) >= 0) {
            return;
          }
          if (self._children[msgId]._data && self._children[msgId]._data.msg) {
            document.oncontextmenu = function () {
              // if (time <= 120) {
              self.triggerEvent('contentMenuOpen', {
                position: {
                  x: e.pageX,
                  y: e.pageY
                },
                timeout: time > 120,
                message: self._children[msgId]._data.msg,
                e   
              });
              // }
              $(document).on('mousedown', closeMenu);
              return false;
            };
          }
        } else {
          document.oncontextmenu = function () {
            return true;
          };
        }
        e.stopPropagation();
      }
    });
    self._element.click(function (e) {
      var _target = $(e.target);
      if (self._options.multiple_select) {

      } else if (['DIV', 'A', 'SPAN'].indexOf(e.target.tagName) >= 0 && _target.hasClass('im-msg-click')) {
        var msg_id = _target.data('msg-id');
        msg_id = self.createKey(msg_id);
        var msgItem = self._children[msg_id];
        if (_target.hasClass('im-msg-ai')) {
          msgItem && self._options.onClick && self._options.onClick(msgItem);
        } else if (_target.hasClass('im-msg-action')) {
          if (msgItem) {
            var index = _target.data('index');
            var message = msgItem._data.msg;
            var actions = message.content.actions;
            if (!isNaN(index) && !isEmpty(msgItem._options.actions_map[index]) && msgItem._options.actions_map[index].action === 'sendMsg') {
              self.triggerEvent('sendMessage', {
                text: msgItem._options.actions_map[index].actionData || msgItem._options.actions_map[index].text
              });
              return;
            }
            if (!isNaN(index) && !isEmpty(msgItem._options.actions_map[index]) && msgItem._options.actions_map[index].action === 'ajax') {
              actions = [{
                actionData: {
                  url: msgItem._options.actions_map[index].actionData,
                  method: msgItem._options.actions_map[index].actionPostData ? 'post' : 'get'
                },
                action: msgItem._options.actions_map[index].action,
                actionPostData: msgItem._options.actions_map[index].actionPostData,
                message: message
              }];
            }
            if (!isEmpty(actions) && actions.length) dispatcher.dispatch({
              type: ActionType.MSG_ACTION,
              data: {
                actionData: actions[0].actionData,
                actionPostData: actions[0].actionPostData,
                action: actions[0].action,
                message: message
              }
            });
          }
        } else if (_target.hasClass('im-false-click')) {
          if (msgItem) {
            var message = msgItem._data.msg;
            if (message.call_type === 'audio' || message.call_type === 'video') {
              self.triggerEvent('falseMsgCall', message.call_type);
            }
          }
        }
      } else if (_target.hasClass('im-msg-redit-content') && !self._options.multiple_select) {
        var redit_content = _target.data('redit-content');
        if (redit_content) self.triggerEvent('reditContent', {
          content: redit_content
        });
      }
    });
  })(this);
};
MsgList.prototype = Object.create(Component.prototype);
MsgList.prototype.createKey = function (msg_id) {
  if (msg_id) {
    return 'perm-' + msg_id;
  }
  else {
    return 'temp-' + msg_id;
  }
};
MsgList.prototype.add = function (msg) {
  /* var self = this;
   var msg_id = msg.msg_id;
   var msgItem;
   if (msg_id) {
   var key = this.createKey(msg_id);
   if (this._children[key])
   return false;

   msgItem = createMsgItem.call(this, msg);
   if (!msgItem)
   return false;
   this._children[key] = msgItem;
   var position = this.setPosition(msg_id);

   if (position === 0) {
   this._element.prepend(msgItem.getElement());
   }
   else {
   var previous_id = this._msg_ids[position - 1];
   var key = this.createKey(previous_id);
   var previous = this._children[key];
   previous.after(msgItem);
   }
   }
   else {
   var key = this.createKey(msg.temp_msg_id);
   if (this._children[key]) {
   this._children[key].setMsg(msg);
   return false;
   }
   msgItem = createMsgItem.call(this, msg);
   if (!msgItem)
   return false;
   //this._msg_ids.push(key);
   this._children[key] = msgItem;
   this._element.append(msgItem.getElement());
   }*/

  // 根据时间进行插入
  var msg_time = msg.send_time && msg.send_time.toString() !== '0' ? msg.send_time : new Date().getTime();
  var msgItem;
  var msg_id = msg.msg_id;
  msg.sort_time = msg_time;

  if (msg_id && msg_id > 0) {
    var key = this.createKey(msg_id);
    if (this._children[key]) {
      return false;
    }

    msgItem = createMsgItem.call(this, msg);
    if (!msgItem)
      return false;
    this._children[key] = msgItem;
    this.setPosition(msg_id);

    // 插入数据
    var pos = getPosition.call(this, msg);
    if (pos < 1) {
      this._element.prepend(msgItem.getElement());
    }
    else {
      var previous_id = this._msg_sorttime[pos - 1].msg_id;
      var key = this.createKey(previous_id);
      var previous = this._children[key];
      if (!isEmpty(previous))
        previous.after(msgItem);
    }
  }
  else {
    msg.msg_id = msg.temp_msg_id;
    // msg.sender_info.device_id = '1111';
    var key = this.createKey(msg.msg_id);
    if (this._children[key]) {
      this._children[key].setMsg(msg);
      return false;
    }
    msgItem = createMsgItem.call(this, msg);
    if (!msgItem)
      return false;

    this._children[key] = msgItem;
    var pos = getPosition.call(this, msg);
    if (pos === 0) {
      this._element.prepend(msgItem.getElement());
    }
    else {
      var previous_id = this._msg_sorttime[pos - 1].msg_id;
      var key = this.createKey(previous_id);
      var previous = this._children[key];
      previous.after(msgItem);
    }
  }


  // 时间戳展示逻辑
  /* if (this._last_timestamp == null) {
   this._last_timestamp = msg.send_time;
   msgItem.showTime();
   }
   else {
   if (msg.send_time - this._last_timestamp > 2 * 60 * 1000) {
   this._last_timestamp = msg.send_time;
   msgItem.showTime();
   }
   else {
   msgItem.hideTime();
   }
   }*/
  return true;

};
MsgList.prototype.hideMsg = function (msgs, cb) {
  if (msgs.length === 0)
  return null;
  var count = 0;
  for (var index = 0; index < msgs.length; index++) {
    key = this.createKey(msgs[index].msg_id);
    com = this._children[key];
    if (!isEmpty(com) && com._show) {
      if (com._data.msg.is_false_new === true) {
        if (msgs[index].send_time !== com._data.msg.send_time && !(msgs[index]._deleted_send_time && msgs[index]._deleted_send_time[com._data.msg.send_time])) {
          continue;
        }
      }
      if (com._data && com._data.msg && com._data.msg.show_type && non_delete_show_types.indexOf(com._data.msg.show_type) < 0) {
        com._data.msg.msg_status = 2;
        com.hide();
        count += 1;
      }
      if (com._data.msg.is_false_new === true) {
        this.remove(null, null, msgs[index].msg_id, true);
      }
    }
  }
  cb && cb(count);
};
// 替换撤回消息
MsgList.prototype.replace = function (msgs, cb) {
  var self = this;
  var msg = self.getReplaceMsg(msgs);
  var me = config['me']();
  var meKey = me.user_id + '@' + me.user_source;
  if (msg && isEmpty(msg.original_content) && msg.is_mine) msg.original_content = $.extend(true, {}, msg.content);
  // 首次进入不需要替换
  if (!msg) {
    return cb();
  }
  var replaceMsgContent = msgs.replace;
  var replaceMsg = replaceMsgContent.content.text;
  msg.show_type = replaceMsgContent.show_type;
  msg.content.type = replaceMsgContent.show_type;
  msg.content.text = replaceMsg;
  msg.temp_msg_id = msg.msg_id;
  msg.replace = msgs.replace;
  if ((_standardEvaluateCardList.indexOf(msg.show_type) !== -1) && replaceMsgContent) {
    msg.content.result = replaceMsgContent.content.result;
    msg.content.status = replaceMsgContent.content.status;
  }
  // 根据时间进行插入
  var msg_time = msg.send_time && msg.send_time.toString() !== '0' ? msg.send_time : new Date().getTime();
  var msgItem;
  var msg_id = msg.msg_id;
  msg.sort_time = msg_time;
  var msg_key = this.createKey(msg.msg_id);
  msgItem = createMsgItem.call(this, msg);
  if (!msgItem)
    return false;
  // 插入数据
  if (msg.msg_status + '' === '2') {
    msgItem.getElement().hide();
  }
  var pos = this.setReplacePosition(msg_id, msg);
  if (pos == 0) {
    var from = typeof this._msg_sorttime[pos - 1] != "undefined" ? this._msg_sorttime[pos - 1].msg_id : null;
    var to = typeof this._msg_sorttime[pos + 1] != "undefined" ? this._msg_sorttime[pos + 1].msg_id : null;
    self.remove(from, to, msg_id);
    this._element.prepend(msgItem.getElement());
  } else if (pos > 0) {
    var previous_id = this._msg_sorttime[pos - 1].msg_id;
    var key = this.createKey(previous_id);
    var previous = this._children[key];
    var from = typeof this._msg_sorttime[pos - 1] != "undefined" ? this._msg_sorttime[pos - 1].msg_id : null;
    var to = typeof this._msg_sorttime[pos + 1] != "undefined" ? this._msg_sorttime[pos + 1].msg_id : null;
    self.remove(from, to, msg_id);
    previous.after(msgItem);
  }
  // var msg_sorttime = {msg_id: msg.msg_id, sort_time: msg.sort_time};
  // self._msg_sorttime.splice(pos+1, 0, msg_sorttime);
  self._msg_ids.splice(pos, 0, msg.msg_id);
  this._children[msg_key] = msgItem;
  cb();
  return true;

};
MsgList.prototype.remove = function (from, to, target_msg_id, full_delete) {
  var length = this._msg_ids.length;
  var to_delete_index = [];
  for (let index = 0; index < length; index++) {
    var msg_id = this._msg_ids[index];
    if (!isEmpty(target_msg_id) && strToNumCompare(msg_id, target_msg_id) == 0) {
      var key = this.createKey(msg_id);
      if (!isEmpty(this._children[key])) {
        this._children[key].destroy();
      }
      delete this._children[key];
      to_delete_index.push(index);
    } /* else {
      var gt_from = from ? strToNumCompare(msg_id, from) > 0 : true;
      if (!gt_from)
        continue;
      var lt_to = to ? strToNumCompare(msg_id, to) < 0 : true;
      if (!lt_to)
        continue;
      var key = this.createKey(msg_id);
      if (!isEmpty(this._children[key])) {
        this._children[key].destroy();
      }
      delete this._children[key];
      to_delete_index.push(index);
    } */
  }

  var length = to_delete_index.length;
  for (var index = length - 1; index >= 0; index--) {
    this._msg_ids.splice(to_delete_index[index], 1);
  }
  if (full_delete) {
    for(let index = 0; index < this._msg_sorttime.length; index++) {
      var _msg_sorttime_item = this._msg_sorttime[index];
      if (!isEmpty(target_msg_id) && strToNumCompare(_msg_sorttime_item.msg_id, target_msg_id) == 0) {
        this._msg_sorttime.splice(index, 1);
        index--;
      }
    }
  }
};
MsgList.prototype.setPosition = function (msg_id) {
  var position = 0;
  var length = this._msg_ids.length;
  $.each(this._msg_ids, function (index, id) {
    position = index;
    if (strToNumCompare(msg_id, id) < 0) {
      return false;
    }
    if (index === length - 1) {
      position++;
    }
  });

  if (position < length) {
    this._msg_ids.splice(position, 0, msg_id);
  }
  else {
    this._msg_ids.push(msg_id);
  }
  return position;
};

// 替换消息位置设置
MsgList.prototype.setReplacePosition = function (msg_id, msg) {
  var self = this;
  var position = -1;
  var msg_sorttime = { msg_id: msg.msg_id, sort_time: msg.sort_time };
  $.each(self._msg_sorttime, function (index, id) {
    if (msg_id == id.msg_id) {
      position = index;
    }
  });
  return position;
};

MsgList.prototype.empty = function () {
};
MsgList.prototype.getOldMsg = function () {
  if (this._msg_ids.length === 0)
    return null;

  var key = this.createKey(this._msg_ids[0]);
  return this._children[key] && this._children[key].getMsg();
};
MsgList.prototype.getFreshMsg = function (has_false) {
  if (this._msg_ids.length === 0)
    return null;
  var msg_ids_index = this._msg_ids.length - 1;
  var id = this._msg_ids[msg_ids_index];
  var key = this.createKey(id);
  if (has_false) {
    return this._children[key] && this._children[key].getMsg();
  } else {
    var msg = this._children[key] && this._children[key].getMsg();
    var self = this;
    if (msg && msg.is_false_new) {
      msg = null;
      for (; msg_ids_index > 0; msg_ids_index--) {
        id = self._msg_ids[msg_ids_index];
        key = self.createKey(id);
        msg = self._children[key] && self._children[key].getMsg();
        if (msg) {
          if (msg.is_false_new) {
            msg = null;
            continue;
          } else {
            break;
          }
        }
      }
    }
    return msg;
  }
};
// 获取被撤回消息
MsgList.prototype.getReplaceMsg = function (msg) {
  var replaceContent = msg.replace;
  if (this._msg_ids.length === 0)
    return null;
  var id = replaceContent.msg_id;
  var key = this.createKey(id);
  return this._children[key] && this._children[key].getMsg();
};
MsgList.prototype.updateMsg = function (msg) {
  var key, com;
  // 对于非发送消息的更新(文件下载、视频播放等检测)
  if (!isEmpty(msg.content) && msg.content.forward_one_by_one) {
    var forward_original_show_type = msg.show_type;
    var forward_original_content = msg.content;
    msg.show_type = msg.forward_msg_show_type;
    msg.content = msg.forward_msg_content;
    msg.forward_original_show_type = forward_original_show_type;
    msg.forward_original_content = forward_original_content;
  }
  if (msg && msg.msg_id && !msg.temp_msg_id) {
    key = this.createKey(msg.msg_id || msg.temp_msg_id);
    com = this._children[key];
    if (!com)
      return;
    com.setMsg(msg);
    return;
  }
  // 发送消息更新
  key = this.createKey(msg.temp_msg_id);
  com = this._children[key];
  if (!com)
    return;
  com.setMsg(msg);
  if (msg.msg_id) {
    //更新msg_sorttime数组
    $.each(this._msg_sorttime, function (index, value) {
      if (value.msg_id && value.msg_id.toString() === msg.temp_msg_id.toString()) {
        value.msg_id = msg.msg_id;
        value.sort_time = msg.send_time;
      }
    });
    var key, com;
    // 对于非发送消息的更新(文件下载、视频播放等检测)
    if (msg && msg.msg_id && !msg.temp_msg_id) {
      key = this.createKey(msg.msg_id || msg.temp_msg_id);
      com = this._children[key];
      if (!com)
        return;
      com.setMsg(msg);
      return;
    }
    // 发送消息更新
    key = this.createKey(msg.temp_msg_id);
    com = this._children[key];
    if (!com)
      return;
    com.setMsg(msg);
    if (msg.msg_id) {
      //更新msg_sorttime数组
      $.each(this._msg_sorttime, function (index, value) {
        if (value.msg_id && value.msg_id.toString() === msg.temp_msg_id.toString()) {
          value.msg_id = msg.msg_id;
          value.sort_time = msg.send_time;
        }
      });

      //更新_msg_ids数组
      var deltIndex;
      $.each(this._msg_ids, function (index, value) {
        if (value.toString() === msg.temp_msg_id.toString()) {
          deltIndex = index;
          return false;
        }
      });
      if (!isEmpty(deltIndex)) {
        this._msg_ids.splice(deltIndex, 1);
      }

      delete this._children[key];
      msg.temp_msg_id = msg.msg_id;
      var key = this.createKey(msg.msg_id);
      this._children[key] = com;
      this.setPosition(msg.msg_id);
    }
  }
};

MsgList.prototype.updateMsgOtherRead = function () {
  var self = this;
  $.each(self._msg_sorttime, function (index, value) {
    var key = self.createKey(value.msg_id);
    var com = self._children[key];
    if (!com || !com._data || !com._data.msg || !com._data.msg.is_mine) {
      return;
    }
    var msg = com._data.msg;
    com.setMsg(msg);
  });
};

// 刷新时间
MsgList.prototype.freshenTime = function () {
  var self = this;
  var lasttime;
  for (var index = 0; index < self._msg_sorttime.length; index++) {
    var item_id = self._msg_sorttime[index].msg_id;
    var key = this.createKey(item_id);
    if (isEmpty(self._children[key])) continue;
    var item_time = self._children[key].getMsg().send_time;
    if (index === 0) {
      self._children[key].showTime();
      lasttime = item_time;
      continue;
    }

    if (item_time - lasttime > 2 * 60 * 1000) {
      self._children[key].showTime();
      lasttime = item_time;
    } else {
      self._children[key].hideTime();
    }

    //展示之后，将_msg_ids里面的临时id删除，以便下一次定时同步_children里
    //if(index==self._msg_ids.length-1&&item_id.split('temp').length==2){
    //    self._msg_ids.pop();
    //}
  }
};
//是否为最后一条消息
MsgList.prototype.isLastMsg = function (index) {
  var self = this;
  return index === self._msg_ids[self._msg_ids.length - 1]
};

MsgList.prototype.multiple_select = function (e) {
  var self = this;
  self._options.multiple_select = true;
  self.triggerEvent('multiple_select_switch', { active: true });
  self.getElement().addClass('multiple_selectable');
  self.getElement().on('click', '.im-msg', self._multiple_select);
  if(!isEmpty(e)){
    self._multiple_select(e);
  }
  // dispatcher.dispatch({
  //   type: ActionType.MULTIPLE_NOTICE,
  //   data: {
  //     notices: [{
  //       name: 'multiple_select',
  //       buttons: [{action:'switchClick', text: '转发', type: 'forward'}]
  //     }]
  //   }
  // });
};

MsgList.prototype.multiple_cancel = function () {
  var self = this;
  self._options.multiple_select = false;
  self.triggerEvent('multiple_select_switch', { active: false });
  self.getElement().removeClass('multiple_selectable');
  self.getElement().find('.im-msg-selected').removeClass('im-msg-selected');
  self.getElement().off('click', '.im-msg', self._multiple_select);
};

MsgList.prototype.multiple_check = function () {
  var self = this;
  var selecteds = self.getElement().find('.im-msg.im-msg-selected');
  var msg_list = [];
  var msg_id;
  var msg_key;
  [].forEach.call(selecteds, function (item) {
    msg_id = $(item).data('msg-id');
    msg_key = self.createKey(msg_id);
    if (msg_id && self._children[msg_key]) {
      msg_list.push(self._children[msg_key]);
    }
  });
  return msg_list;
};
MsgList.prototype.addCollectMsg = function (msg) {
  var msg_time = msg.send_time && msg.send_time.toString() !== '0' ? msg.send_time : new Date().getTime();
  var msgItem;
  var collect_id = msg.collect_id;
  msg.sort_time = msg_time;
  if (collect_id && collect_id > 0) {
    var key = this.createKey(collect_id);
    if (this._children[key])
      return false;
    msgItem = createMsgItem.call(this, msg);
    if (!msgItem)
      return false;
    this._children[key] = msgItem;
    // 插入数据
    this._element.append(msgItem.getElement());
  }
  this.setPosition(collect_id);
};
module.exports = MsgList;
